import axios from 'axios'
import { withHeadersInstance } from './api-instance'
import qs from 'qs'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetPartner = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/partner/${publicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutPartner = async function(parameters) {
    try {
        const { formData, publicId } = parameters
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/partner/${publicId}`,
            data: formData,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeletePartner = async function(parameters) {
    try {
        const { publicId } = parameters

        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/partner`,
            data: publicId,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/partners${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostPartner = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/partner`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangePartnerStatus = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined) {
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        }

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/partner/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
